import BaseModel from "./BaseModel";
import { useContextStore } from "@/stores/context";

/**
 * Country
 */
export default class Country extends BaseModel{

  constructor({
    id,
    name,
    code,
    category,
    en,
    pt,
    es
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.code = code || null;
    this.category = category || null;
    this.en = en || null;
    this.pt = pt || null;
    this.es = es || null;
  }

  /**
   * Gets translated country name
   * @param {Bool} translated - to return name translated
   * @returns {String}
   */
  getName(translated = true) {
    if (translated) {
      const contextStore = useContextStore();
      return this[contextStore.getLang] != null ? this[contextStore.getLang] : this.en;
    }
    return this.name;
  }
}